// components/CaptchaReact.tsx
import React, { forwardRef } from 'react'
import HCaptcha from '@hcaptcha/react-hcaptcha'
import ReCAPTCHA from 'react-google-recaptcha'
import { FeatureFlag } from '@/app/[lng]/Classses/FetatureFlag'
import { cookieCaptchaEnabled } from '@/app/utils/cookiesConsent'
import { RootState } from '@/app/globalRedux/store'
import { useSelector } from 'react-redux'

const recaptchaSiteKey =
  process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_V2_CLIENT_TOKEN || ''
const hCaptchaSiteKey = process.env.NEXT_PUBLIC_HCAPTCHA_CLIENT_TOKEN || ''

interface CaptchaReactProps {
  onVerify?: (token: string, ekey?: string) => void
  onChange?: (value: string | null) => void
}

const FeatureFlagCaptcha = forwardRef<HCaptcha | ReCAPTCHA, CaptchaReactProps>(
  ({ onVerify, onChange }, ref) => {
    const featureFlags = useSelector(
      (state: RootState) => state.featureFlag
    )?.feature_flags
    const captchaType = FeatureFlag.getCaptchaType(featureFlags)
    const captchaEnabled = FeatureFlag.getNeedCaptcha(featureFlags)

    const isHcaptcha = captchaType === 'hCaptcha'
    const shouldRenderCaptcha = captchaEnabled && cookieCaptchaEnabled()

    if (isHcaptcha && !hCaptchaSiteKey) {
      console.error(
        '[Captcha Error] hCaptcha site key is missing. check your environment variables.'
      )
    }

    if (!isHcaptcha && !recaptchaSiteKey) {
      console.error(
        '[Captcha Error] reCAPTCHA site key is missing. check your environment variables.'
      )
    }

    const handleVerify = (token: string, ekey: string) => {
      onVerify?.(token, ekey)
    }

    return (
      <>
        {shouldRenderCaptcha && (
          <>
            {isHcaptcha ? (
              <HCaptcha
                sitekey={hCaptchaSiteKey}
                onVerify={handleVerify}
                ref={ref as React.Ref<HCaptcha>}
              />
            ) : (
              <ReCAPTCHA
                sitekey={recaptchaSiteKey}
                onChange={onChange}
                ref={ref as React.Ref<ReCAPTCHA>}
              />
            )}
          </>
        )}
      </>
    )
  }
)

FeatureFlagCaptcha.displayName = 'CaptchaReact'

export default FeatureFlagCaptcha
